module.exports = __webpack_public_path__ + "mbg.32ed2cc10af0040b5eaf.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/johnn/Documents/things/innovajsl/src/assets/images/mbg/mbg.jpg
// module id = ../../../../../src/assets/images/mbg/mbg.jpg
// module chunks = styles